import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChainsService {
    /**
     * Get User Mapped Chains
     * @returns any Successful Response
     * @throws ApiError
     */
    static getUserMappedChainsUserChainsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/user/chains',
        });
    }
    /**
     * Get Chains
     * @param activeOnly
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainsChainsGet(activeOnly = true) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chains',
            query: {
                'active_only': activeOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create One
     * @param requestBody
     * @returns Chain Successful Response
     * @throws ApiError
     */
    static routeChainsPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain
     * @param chainName
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainChainsChainIdGet(chainName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chains/{chain_id}',
            query: {
                'chain_name': chainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Chain Status
     * @param chainName
     * @param active
     * @returns any Successful Response
     * @throws ApiError
     */
    static setChainStatusChainsStatusSetPost(chainName, active = true) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains/status/set',
            query: {
                'chain_name': chainName,
                'active': active,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Status
     * @param chainName
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainStatusChainsStatusGetGet(chainName) {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chains/status/get',
            query: {
                'chain_name': chainName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Chain Status
     * @param requestBody
     * @returns any Successful Response
     * @throws ApiError
     */
    static setChainStatusChainsStatusBulkSetPost(requestBody) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains/status/bulk/set',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Status
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainStatusChainsStatusBulkGetGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chains/status/bulk/get',
        });
    }
    /**
     * Group Chain
     * @param chainName
     * @param chainGroupName
     * @returns any Successful Response
     * @throws ApiError
     */
    static groupChainChainsGroupPost(chainName, chainGroupName) {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/chains/group',
            query: {
                'chain_name': chainName,
                'chain_group_name': chainGroupName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Chain Groups
     * @returns any Successful Response
     * @throws ApiError
     */
    static getChainGroupsChainGroupsGet() {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/chain-groups',
        });
    }
    /**
     * Update One
     * @param itemId
     * @param requestBody
     * @returns Chain Successful Response
     * @throws ApiError
     */
    static routeChainsItemIdPut(itemId, requestBody) {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/chains/{item_id}',
            path: {
                'item_id': itemId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
    /**
     * Delete One
     * @param itemId
     * @returns Chain Successful Response
     * @throws ApiError
     */
    static routeChainsItemIdDelete(itemId) {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/chains/{item_id}',
            path: {
                'item_id': itemId,
            },
            errors: {
                404: `Not Found`,
                422: `Validation Error`,
            },
        });
    }
}
